import {
  getCLS, getFID, getFCP, getLCP,
} from 'web-vitals';
import { triggerCustomEvent } from 'lib/helpers';

const collectWebVitals = (data) => {
  triggerCustomEvent('snowplow:web_vitals_report', data);
};

window.addEventListener('DOMContentLoaded', () => {
  getFCP(collectWebVitals);
  getCLS(collectWebVitals, true);
  getFID(collectWebVitals);
  getLCP(collectWebVitals);
});
